import { render } from "./SocialsForm.vue?vue&type=template&id=10c6ed96&scoped=true"
import script from "./SocialsForm.vue?vue&type=script&lang=js"
export * from "./SocialsForm.vue?vue&type=script&lang=js"

import "./SocialsForm.vue?vue&type=style&index=0&id=10c6ed96&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c6ed96"]])

export default __exports__